import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { PopupRef } from '@local/ui-infra';
import { UntilDestroy } from '@ngneat/until-destroy';
import { HubService } from '../../services/hub.service';

export interface MessagePopupModel {
  title?: string;
  description?: string;
  action?: MessagePopupActionModel;
}

export interface MessagePopupActionModel {
  text: string;
  icon?: string;
  url: string;
}

@UntilDestroy()
@Component({
  selector: 'message-popup',
  templateUrl: './message-popup.component.html',
  styleUrl: './message-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessagePopupComponent implements OnInit {
  data = signal<MessagePopupModel>(null);

  constructor(
    private ref: PopupRef<MessagePopupComponent, MessagePopupModel>,
    private hubService: HubService
  ) {}

  ngOnInit(): void {
    this.data.set(this.ref.data);
  }

  closePopup() {
    this.ref.destroy();
  }

  onActionClick() {
    this.hubService.openUrl(this.data().action.url);
    this.closePopup();
  }
}
